import { memo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { useFlags } from '@mint-lib/routing-context';
import {
  EmailIntegrations,
  GhostIntegrations,
} from '@mint-sdk/api-integrations';

import { useGetEmails } from '../../../api/queries/useGetEmails.js';
import type { Email } from '../../../types/index.js';
import EmailRecosPage from './EmailRecosPage.jsx';

type Props = {
  integration: string;
  platformType: string;
};

const defaultInitValue = {
  emails: [] as Email[],
};

const EmailRecosForm = ({ integration, platformType }: Props) => {
  const { newGhostEmailApi } = useFlags('@mint/arm', ['newGhostEmailApi']);

  //TODO: Remove saveEmailsMutation when newGhostEmailApi FF  is enabled on PROD
  const { mutate: saveEmailsMutation } = EmailIntegrations.saveEmails();
  const { mutate: saveEmailsMutationV2 } = EmailIntegrations.saveEmailsV2();
  const { data: ghostPlatforms = [] } = GhostIntegrations.get.use({});
  const { data: emails, isLoading: isEmailLoading } = useGetEmails(integration);

  const handleFormSubmit = async (values: { [key: string]: any }) => {
    const emailValues = values.emails.map((value: Email) => value.email);

    if (newGhostEmailApi.enabled) {
      const currentGhost = ghostPlatforms.find(
        (p) => p.provider === integration,
      );

      if (currentGhost) {
        saveEmailsMutationV2({
          data: {
            emails: emailValues,
            integrationId: currentGhost.id,
            platformName: integration,
          },
        });
      }
    } else {
      saveEmailsMutation({
        data: { emails: emailValues },
        params: {
          integrationId: integration,
          platformType,
        },
      });
    }
  };

  let initValues = { ...defaultInitValue };
  if (emails?.length) {
    initValues = { emails };
  }

  const methods = useForm({
    mode: 'onBlur',
    values: initValues,
  });

  return (
    <FormProvider {...methods}>
      <EmailRecosPage
        isEmailLoading={isEmailLoading}
        handleFormSubmit={handleFormSubmit}
      />
    </FormProvider>
  );
};

export default memo(EmailRecosForm);
